import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { AdminLayoutModule } from '../../admin-layout/admin-layout.module';
import { ReportsComponent } from './reports.component';
import { TimetableOverviewComponent } from './timetables/timetable-overview/timetable-overview.component';
import { CoreModule } from '../../core/core.module';
import { SharedModule } from '../../shared/shared.module';
import { ShivePopupDirective } from '../../core/directives/shive-popup.directive';
import { TimetableMonthsComponent } from './timetables/timetable-months/timetable-months.component';
import { TimetableYearSelectionComponent } from './timetables/shared/timetable-year-selection/timetable-year-selection.component';
import { TimetableEntriesComponent } from './timetables/timetable-entries/timetable-entries.component';
import { TimeFormatPipe } from '../../core/pipes/time-format.pipe';

@NgModule({
  declarations: [
    ReportsComponent,
    TimetableOverviewComponent,
    TimetableMonthsComponent,
    TimetableYearSelectionComponent,
    TimetableEntriesComponent,
  ],
  imports: [
    CommonModule,
    CoreModule,
    SharedModule,
    ShivePopupDirective,
    TimeFormatPipe,
    AdminLayoutModule,
  ],
  providers: [DecimalPipe],
})
export class ReportsModule {}
